import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <div className="fixed bottom-8 right-8 z-50">
            {isVisible && (
                <Button
                    onClick={scrollToTop}
                    size="icon"
                    className="rounded-full bg-tasktide-dark text-white shadow-lg hover:bg-black transition-all animate-scale-in dark:bg-white dark:text-black dark:hover:bg-gray-200"
                >
                    <ArrowUp className="h-5 w-5" />
                </Button>
            )}
        </div>
    );
};

export default ScrollToTop;
